import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createMutePlayerOutbound, createUnmutePlayerOutbound } from '../../../api/outbound/commonOutbounds';
import { MenuItemContainer } from '../../../components/menuItemContainer';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { MutePlayerIcon } from '../../../icons/mutePlayerIcon';
import { UnmutePlayerIcon } from '../../../icons/unmutePlayerIcon';
import { thunkSetActivePanel } from '../../../redux/actions/panelsActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
const NUM_MUTE_MINUTES = 15;
export const PlayerMutingAdminActionsMenuItems = ({ playerIdName, closeMenu }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const isPlayerInRoom = useAppSelector((state) => {
        switch (state.scene.roomSceneType) {
            case 'poker': {
                return state.poker.players.some((player) => player.id === playerIdName.id);
            }
            case 'lobby': {
                return state.lobby.lobbyPlayers.some((lobbyPlayer) => lobbyPlayer.id === playerIdName.id);
            }
            case 'mttStaging': {
                return state.mttStaging.players.some((mttStagingPlayer) => mttStagingPlayer.id === playerIdName.id);
            }
            case undefined: {
                return false;
            }
        }
    });
    const onClickMute = useCallback(() => {
        socketSend(createMutePlayerOutbound(playerIdName.name, NUM_MUTE_MINUTES));
        dispatch(thunkSetActivePanel('chat', socketSend));
    }, [dispatch, socketSend, playerIdName.name]);
    const onClickUnmute = useCallback(() => {
        socketSend(createUnmutePlayerOutbound(playerIdName.name));
        dispatch(thunkSetActivePanel('chat', socketSend));
    }, [dispatch, socketSend, playerIdName.name]);
    if (!isPlayerInRoom) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(MenuItemContainer, { label: `Mute ${NUM_MUTE_MINUTES} Minutes`, svgIconComponent: MutePlayerIcon, onClick: onClickMute, closeMenu: closeMenu }), _jsx(MenuItemContainer, { label: 'Unmute', svgIconComponent: UnmutePlayerIcon, onClick: onClickUnmute, closeMenu: closeMenu })] }));
};
